"use client";
import { useEffect, useRef } from "react";
import { useRouter } from "next/navigation";

function normalize(path) {
    if (!path) return "/";
    if (path === "/") return "/";
    return path.replace(/\/+$/g, "");
}

export default function ScrollNavigator({ sequence = [] }) {
    const router = useRouter();
    const navigating = useRef(false);

    useEffect(() => {
        if (!sequence || sequence.length === 0) return;

        const normalized = sequence.map(normalize);

        const onScroll = () => {
            if (navigating.current) return;

            const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 40;
            if (!atBottom) return;

            navigating.current = true;
            const currentPath = normalize(window.location.pathname);
            let idx = normalized.indexOf(currentPath);
            if (idx === -1) idx = 0;
            const nextIdx = (idx + 1) % normalized.length;
            const next = normalized[nextIdx];
            // small delay to allow user to see bottom
            setTimeout(() => {
                router.push(next);
                // prevent rapid re-navigation
                setTimeout(() => (navigating.current = false), 800);
            }, 200);
        };

        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [sequence, router]);

    return null;
}
